module.exports = __webpack_public_path__ + "img/icon_t5.1e467ef2.png";